import CargoSpecFcl from "./cargo-specs-fcl.component";

export default CargoSpecFcl;
